/* eslint-disable @typescript-eslint/member-ordering */

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

let nextTextareaId = 0;

/** Usage: bind with formControlName; maxLength adds a visible character counter. */
@Component({
  selector: 'app-textarea',
  templateUrl: './app-textarea.component.html',
  styleUrls: ['./app-textarea.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => AppTextareaComponent), multi: true }]
})
export class AppTextareaComponent implements ControlValueAccessor {
  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  @Input() label = '';
  @Input() placeholder = '';
  @Input() required = false;
  @Input() errorText = '';
  @Input() rows = 4;
  @Input() maxLength: number | null = null;
  @Input() removeDefaultVerticalPadding = false;
  readonly textareaId = `app-textarea-${nextTextareaId++}`;
  value = '';
  disabled = false;

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: string | null): void {
    this.value = value || '';
    this.changeDetectorRef.markForCheck();
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
    this.changeDetectorRef.markForCheck();
  }

  onInput(event: CustomEvent<{ value?: string | null }>): void {
    // Ionic 6 emits the native input event in detail; the value is on the host.
    const inputElement = event.target as { value?: string | null } | null;
    this.value = event.detail?.value ?? inputElement?.value ?? '';
    this.onChange(this.value);
  }

  onBlur(): void {
    this.onTouched();
  }
}
